import React from 'react';
import Button from '@material-ui/core/Button';

import Box from '../../../components/basic/box'

import {inject,observer} from 'mobx-react';
@inject('translate')
@inject('internal')
@observer
export default class ResetSuccess extends React.Component {

    render() {
        return (
            <Box>
                <h5>{this.props.translate.i18n.LOGIN.SUCCES_SEND_REQUEST}</h5>
                <Button
                    className={'btn-white-bg'}
                    href="/">
                    {this.props.translate.i18n.LOGIN.BACK_TO_LOGIN}
                </Button>
            </Box>
        );
    }
}


// WEBPACK FOOTER //
// ./src/screens/reset/success/index.js